const WHATSAPP_LINK = "https://wa.me/557183822916";

const areas = [
  {
    icon: "ri-file-text-line",
    title: "Consultoria Jurídica",
    description:
      "Orientação especializada para tomada de decisões seguras, prevenção de litígios e gestão de riscos jurídicos com análise técnica aprofundada.",
  },
  {
    icon: "ri-gavel-line",
    title: "Atuação Contenciosa",
    description:
      "Representação processual qualificada perante os órgãos do Poder Judiciário, com estratégia definida e acompanhamento integral de cada processo.",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Assessoria Jurídica",
    description:
      "Suporte jurídico contínuo para pessoas físicas e empresas, com análise preventiva de contratos, documentos e situações jurídicas complexas.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Análise de Riscos Jurídicos",
    description:
      "Identificação, avaliação e gestão de riscos jurídicos com foco na proteção patrimonial e na segurança das relações do cliente.",
  },
];

export default function AreasAtuacao() {
  return (
    <section id="atuacao" className="bg-petrol-dark py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-gold-light/50" />
            <span className="text-gold-light text-xs font-semibold tracking-widest uppercase">
              Áreas de Atuação
            </span>
            <div className="w-8 h-px bg-gold-light/50" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Atuação jurídica abrangente <br />
            e <span className="text-gold-light">tecnicamente qualificada</span>
          </h2>
          <p className="text-white/60 text-base max-w-xl mx-auto leading-relaxed">
            Cada área é conduzida com rigor técnico, estratégia individualizada
            e compromisso com os melhores resultados para o cliente.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {areas.map((area, idx) => (
            <div
              key={area.title}
              className="group relative bg-petrol-medium/60 border border-white/10 hover:border-gold-light/40 rounded-lg p-8 transition-all duration-400 flex flex-col cursor-default"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              {/* Content */}
              <h3 className="text-white font-semibold text-lg mb-3">{area.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed flex-1">{area.description}</p>

              {/* CTA */}
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 text-gold-light text-xs font-semibold mt-6 group-hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Falar com especialista
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
